import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreOperatingAreasModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ItemSelectorModule } from 'app/item-selector/item-selector.module';
import { OperatingAreasFormComponent } from './operating-areas-form/operating-areas-form.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreOperatingAreasModule,
    TrackingModule,
    UiModule,
    ItemSelectorModule,
  ],
  declarations: [OperatingAreasFormComponent],
  exports: [OperatingAreasFormComponent],
})
export class OperatingAreasModule {}
